import { render, staticRenderFns } from "./ClientComponent.vue?vue&type=template&id=0202fe28&"
import script from "./ClientComponent.vue?vue&type=script&lang=js&"
export * from "./ClientComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports